/**
 * Rimuove il campo `history` da un documento Firestore prima di metterlo
 * nello store Redux. Usato dai listener `onSnapshot` per evitare che
 * audit log (anche con 50+ entry per doc) gonfino la memoria e causino
 * re-render inutili dovuti a riferimenti array sempre nuovi.
 *
 * @param {object} doc - oggetto di tipo `doc.data()` (può contenere `history`).
 * @returns {object} stesso documento senza la chiave `history`.
 */
export const stripHistory = (doc) => {
  if (!doc || typeof doc !== 'object') return doc;
  if (!('history' in doc)) return doc;
  const { history, ...rest } = doc;
  return rest;
};
